import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoadingAction } from '../models/loading-action.enum';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  public loading$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private loadingEvents$: BehaviorSubject<string[]> = new BehaviorSubject([]);

  constructor() {}

  public startLoading(): void {
    this.loading$.next(true);
  }

  public stopLoading(): void {
    this.loading$.next(false);
  }

  public isLoading(): boolean {
    return this.loading$.getValue();
  }

  public watch(event: ILoadingEvent): Observable<boolean> {
    const eventName = this.getEventName(event);
    return this.loadingEvents$.pipe(map((events: string[]) => events.indexOf(eventName) > -1));
  }

  public event(name: string): void {
    this.startLoading();

    this.loadingEvents$.next([...this.loadingEvents$.value, name]);
  }

  public removeEvent(name: string): void {
    this.stopLoading();

    this.loadingEvents$.next(this.loadingEvents$.value.filter((item) => item !== name));
  }

  private getEventName(event: ILoadingEvent): string {
    return `${event.action}_${event.namespace}_${event.id}`;
  }
}

interface ILoadingEvent {
  action: LoadingAction;
  namespace: string;
  id: string;
}
